import { render, staticRenderFns } from "./fixture.vue?vue&type=template&id=717b6389&"
import script from "./fixture.vue?vue&type=script&lang=js&"
export * from "./fixture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports